/**
 * Pull a human-readable message out of an openapi-fetch `error` body.
 *
 * NestJS returns `{ statusCode, message }` where `message` is a string for
 * thrown `HttpException`s (`'status_id is not supported on STAGED boards'`)
 * but a `string[]` for `ValidationPipe` failures, so both shapes have to be
 * handled. Anything unrecognised falls back to the caller's own copy rather
 * than leaking a stringified object at the user.
 */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const message = (error as { message?: unknown } | null | undefined)?.message;

  if (typeof message === 'string' && message.trim()) return message;

  if (Array.isArray(message)) {
    const joined = message.filter((m) => typeof m === 'string').join(', ');
    if (joined.trim()) return joined;
  }

  return fallback;
};
